<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import { BaseURLV3 } from '../shared/classes'
import router from '../router/index'
import Vue from 'vue'
import $ from 'jquery'
import { ToggleButton } from 'vue-js-toggle-button'
// import { VTooltip } from 'v-tooltip'
// Vue.use(VTooltip)
// Vue.directive('tooltip', VTooltip.VTooltip)
export const eventBus = new Vue()

const formShape = {
  job_tittle: '',
  year_of_experience: '',
  month_of_experience: '',
  post_validity: '',
  primarySkils: '',
  secoundarySkills: '',
  job_interview_type: 'video',
  job_description_template: '',
  org_description: '',
  job_comments: '',
  isclient: '',
  client_name: '',
  client_emailid: '',
  dept_name: '',
  role_name: '',
  businessunit_id: '',
  bull_horn_number: '',
  sit: ''
}
export default {
  name: 'custom-modal',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      pskillerror: false,
      Sskillerror: false,
      preFill: false,
      primarySkils: '',
      pSkils: [],
      sSkils: [],
      config: [],
      jobtemplate: [],
      otheremailList: [],
      otherEmails: '',
      jobtemplatelength: 0,
      roletemplate: [],
      roletemplatelength: 0,
      businessunitlist: [],
      businessunitlength: 0,
      tempf: [],
      form: Object.assign({}, formShape),
      createPostStatus: false,
      introStatus: true,
      disabledDates: {
        to: new Date(Date.now() - 8640000)
      },
      minDatetime1: '',
      inputs: [],
      uniqIdList: [],
      secondaryinputs: [],
      isLoading: false,
      shwopostbtn: 'yes',
      files: [],
      createstatus: false,
      businessunit_error: false,
      secondexp: '',
      secondmon: '',
      primexp: '',
      primmon: '',
      topyear: '',
      pvalidation: '',
      client: false,
      quessclient: false,
      clientemail_error: false,
      clientname_error: false,
      showRole: false,
      rolename_error: false,
      bullhorn_required: false,
      bullhorn_invalid: false,
      other_pskillerror: false,
      shwovalueAddPost: true
    }
  },
  props: [
    // 'shwovalueAddPost',
    'resumefiles'
  ],
  created () {
  },
  mounted () {
    this.config = {
      headers: {
        'content-type': 'application/json',
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      }
    }
    var data = {
      search: ''
    }
    axios.post(BaseURLV3 + '/org/skills', data, this.config).then(response => {
      this.pSkils = response.data.skills
      this.sSkils = response.data.skills
    }).catch(e => {
    })
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    this.minDatetime1 = year + '-' + month + '-' + day
    d.setDate(d.getDate() + 10)
    var day1 = this.addZero(d.getDate())
    var month1 = this.addZero(d.getMonth() + 1)
    var year1 = this.addZero(d.getFullYear())
    var postValidity = year1 + '-' + month1 + '-' + day1
    this.form.post_validity = postValidity
    this.form.year_of_experience = 6
    this.form.month_of_experience = 0
    this.files = this.resumefiles
    var name1 = this.resumefiles[0].name.split('.')
    this.form.job_tittle = name1[0]
    console.log('this.resumefiles123 ', this.resumefiles)
    this.updateyear()
  },
  components: {
    Multiselect, ToggleButton
  },
  computed: {
    formStr () {
      return JSON.stringify(this.form, null, 4)
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isDirty () {
      return this.$v.form.$anyDirty
    },
    invCheck () {
      return 'You must accept before submitting'
    }
  },
  mixins: [validationMixin],
  validations: {
    form: {
      job_tittle: {
        required,
        maxLength: maxLength(64)
      },
      year_of_experience: {
        required
      },
      month_of_experience: {
        required
      },
      post_validity: {
        required
      },
      primarySkils: {
        required
      },
      secoundarySkills: {
        // required
      },
      job_interview_type: {
        required
      },
      job_description_template: {
        // required
      },
      org_description: {
        required
      },
      job_comments: {
        // required
      },
      isclient: {

      },
      client_name: {},
      role_name: {},
      client_emailid: {
        email
      },
      dept_name: {
        // required
      },
      businessunit_id: {

      },
      bull_horn_number: {},
      sit: {}
    }
  },
  methods: {
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    closePost () {
      this.$emit('createpost_emit', false)
    },
    introClose () {
      this.introStatus = false
    },
    ValidateAlpha (event) {
      var charCode = (event.which) ? event.which : event.keyCode
      console.log(charCode)
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        return true
      } else {
        event.preventDefault()
      }
    },
    updateyear () {
      console.log(this.form.year_of_experience)
      this.topyear = this.form.year_of_experience
    },
    removeerrorp () {
      this.pskillerror = false
    },
    fileUpload (e) {
      console.log(e.target.files)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        this.files.push(e.target.files[k])
      }
      $('#file').val('')
      console.log(this.files)
    },
    removeUploading (index) {
      this.files.splice(index, 1)
      console.log(this.files)
    },
    resetvalue () {
      console.log('check')
      this.form.job_tittle = ''
      this.form.businessunit_id = ''
      this.form.role_name = ''
      this.form.year_of_experience = ''
      this.form.month_of_experience = ''
      this.form.post_validity = ''
      this.form.primarySkils = ''
      this.form.secoundarySkills = ''
      this.form.job_interview_type = 'video'
      this.form.job_description_template = ''
      this.form.org_description = ''
      this.form.job_comments = ''
      this.form.primarySkils = []
      this.inputs = []
      this.secondaryinputs = []
      this.form.secoundarySkills = []
      this.files = []
      this.jobtemplate = []
      this.jobtemplatelength = 0
      this.form.role_name = ''
      this.form.bull_horn_number = ''
      this.form.businessunit_id = ''
      this.form.client_name = ''
      this.form.client_emailid = ''
      this.form.dept_name = ''
      this.preFill = false
      this.add()
      this.addsecondaryskill()
      this.createstatus = false
      $('.custom-file-upload').removeClass('is-invalid')
      this.$v.$reset()
    },
    add () {
      this.primexp = this.form.year_of_experience
      this.primmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.primarySkils.length
      const temp = this.inputs.length
      this.tempf = this.inputs
      this.inputs = []
      this.sSkils = this.pSkils
      let k = 0
      for (k = 0; k < this.form.primarySkils.length; k++) {
        // var y = ''
        // var m = ''
        // this.sSkils.splice(this.form.primarySkils[k].id, 1)
        let check = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.primarySkils[k].id) {
              this.inputs.push({
                skill_id: this.form.primarySkils[k].id,
                skill_name: this.form.primarySkils[k].name
                // year: item.year_of_experience,
                // month: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          console.log('vava')
          console.log(this.form.primarySkils)
          console.log(this.tempf)
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.primarySkils[k].id) {
              this.inputs.push({
                skill_id: this.form.primarySkils[k].id,
                skill_name: this.form.primarySkils[k].name
                // year: item.year_of_experience,
                // month: item.month_of_experience
              })
              check = 1
            }
          })
        }
        if (check === 0) {
          console.log(this.form.primarySkils[k].year_of_experience)
          // if (this.form.primarySkils[k].year_of_experience === undefined) {
          //   y = 0
          // } else {
          //   y = this.form.primarySkils[k].year_of_experience
          // }
          // if (this.form.primarySkils[k].month_of_experience === undefined) {
          //   m = 0
          // } else {
          //   m = this.form.primarySkils[k].month_of_experience
          // }
          this.inputs.push({
            skill_id: this.form.primarySkils[k].id,
            skill_name: this.form.primarySkils[k].name
            // year: y,
            // month: m
          })
        }
        console.log(check)
      }
    },
    addsecondaryskill () {
      // ssdds
      this.secondexp = this.form.year_of_experience
      this.secondmon = this.form.month_of_experience
      this.tempf = []
      const org = this.form.secoundarySkills.length
      const temp = this.secondaryinputs.length
      this.tempf = this.secondaryinputs
      this.secondaryinputs = []
      let k = 0
      for (k = 0; k < this.form.secoundarySkills.length; k++) {
        let check = 0
        // var y = 0
        // var m = 0
        if (temp > 0 && temp < org) {
          this.tempf.forEach(item => {
            if (item.skill_id === this.form.secoundarySkills[k].id) {
              this.secondaryinputs.push({
                skill_id: this.form.secoundarySkills[k].id,
                skill_name: this.form.secoundarySkills[k].name
                // year: item.year_of_experience,
                // month: item.month_of_experience
              })
              check = 1
            }
          })
        } else if (temp > 0 && temp > org) {
          console.log('vava')
          for (let o = 0; o < this.tempf.length; o++) {
            if (this.tempf[o].skill_id === this.form.secoundarySkills[k].id) {
              // y = this.tempf[o].year_of_experience
              // m = this.tempf[o].month_of_experience
            }
          }
          console.log('zero')
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name
            // year: y,
            // month: m
          })
          check = 1
        }
        if (check === 0) {
          // if (this.form.secoundarySkills[k].year_of_experience === undefined) {
          //   y = 0
          // } else {
          //   y = this.form.secoundarySkills[k].year_of_experience
          // }
          // if (this.form.secoundarySkills[k].month_of_experience === undefined) {
          //   m = 0
          // } else {
          //   m = this.form.secoundarySkills[k].month_of_experience
          // }
          console.log('zerooo')
          this.secondaryinputs.push({
            skill_id: this.form.secoundarySkills[k].id,
            skill_name: this.form.secoundarySkills[k].name
            // year: y,
            // month: m
          })
        }
      }
    },
    editPost () {
      this.preFill = false
      this.form.sit = ''
    },
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    uploading () {
      console.log(this.files)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      console.log('upload 1')
      const formData = new FormData()
      for (let k = 0; k < this.files.length; k++) {
        formData.append('jd', this.files[k])
      }
      console.log('upload 2')
      if (this.files.length > 0) {
        axios.post(BaseURLV3 + '/org/' + this.post_id + '/upload_jd',
          formData, config).then(response => {
          console.log('upload 3')
          this.closePost()
          this.$root.$emit('message_from_createdPost', this.post_id)
          // window.location.href = '/Dashboard'
          this.shwovalueAddPost = false
          this.$awn.success('ID created successfully')
          router.push({ name: 'DashboardV3' })
        }).catch(e => {
          console.log(e)
        })
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })
      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    onSubmitProfile () {
      this.userInfo = JSON.parse(localStorage.getItem('user__details'))
      // this.pskillsvalidation()
      console.log(this.form)
      if (this.client) {
        if (!this.form.client_name) {
          this.clientname_error = true
        } else {
          this.clientname_error = false
        }
        if (!this.form.client_emailid) {
          this.clientemail_error = true
        } else {
          this.clientemail_error = false
        }
      }
      console.log('inputs ', this.inputs)
      console.log('secondaryinputs ', this.secondaryinputs)
      if (this.validate()) {
        this.form.businessunit_id = 0
        console.log('well')
        console.log(this.pvalidation)
        if (this.pvalidation === 1) {
          return false
        }
        if (this.client) {
          if (!this.form.client_name) {
            return false
          }
          if (!this.form.client_emailid) {
            return false
          }
        }
        var formData = {
          post_type: 'id',
          job_title: this.form.job_tittle,
          post_validity: this.form.post_validity,
          template: this.form.job_description_template,
          year_of_experience: this.form.year_of_experience,
          month_of_experience: this.form.month_of_experience,
          primary: this.inputs,
          secondary: this.secondaryinputs,
          job_comments: this.form.org_description,
          remarks: this.form.job_comments,
          user_id: this.userInfo.user_id,
          // max_year_of_experience: this.form.job_tittle,
          // max_month_of_experience: this.form.job_tittle,
          // location: this.form.job_tittle,
          client_name: this.form.client_name,
          client_email: this.form.client_emailid
        }
        console.log('formData ', formData)
        this.$nextTick(() => {
          this.form.isclient = 'no'
          this.shwopostbtn = 'no'
          console.log('chc')
          var mainurl = ''
          mainurl = '/org/' + this.userInfo.id + '/post'
          axios.post(BaseURLV3 + mainurl, formData, this.config).then(response => {
            if (response.data.success) {
              console.log('cee')
              this.preFill = false
              this.shwopostbtn = 'yes'
              this.createstatus = true
              this.post_id = response.data.post.id
              this.uploading()
              $('#modal-default').modal('hide')
              this.shwovalueAddPost = false
              this.createPostStatus = false
            } else {
              this.$awn.error('Error occured')
            }
            // this.shwovalueAddPost = false
            // this.$awn.success('Post created successfully')
            // router.push({ name: 'DashboardNew' })
            // setTimeout(function () { router.push({ name: 'DashboardNew' }) }, 100)
          }).catch(e => {
          })
        })
      } else {
        console.log('validation fail................')
      }
    }
  }
}
</script>

<template>
  <div class="modal fade1 in" id="modal-default" style="display: block;" :v-if="shwovalueAddPost">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true" @click="closePost()">×</span>
          </button>
          <h4>Create Interviewer Description ID</h4>
          <div class="custom-post-title-msg is-4 text-bold fw-400" v-if="introStatus">Note: Once you post, relevant interviewers will be notified to show interest
            <span class="in-close" @click="introClose()"></span>
          </div>
        </div>
        <div class="modal-body">
          <div class="card-body">
            <b-form class="register-form" id="resets" v-on:submit.prevent="onSubmitProfile" novalidate>
              <div class="col-md-12 p-1">
                <label class="immediate-new-label pull-right">
                  Creating on behalf of client
                  <toggle-button id="clienttoggle" v-model="client" color="#5BAD2B" :labels="{checked: 'yes', unchecked: 'No'}" />
                </label>
              </div>
              <div class="form-row" v-if="client">
                <div class="form-group">
                  <label>Client Name</label>
                  <b-form-input style="height: 40px !important" v-model.lazy.trim="$v.form.client_name.$model" @keyup="clearerror()" @keypress="ValidateAlpha($event)" type="text" placeholder="Client Name*" v-bind:class="{ 'is-invalid': clientname_error}"/>
                  <div v-if="clientname_error">
                    <p v-if="clientname_error" class="login-alert-msg error-content">* Enter the client name</p>
                  </div>
                </div>
                <div class="form-group">
                  <label>Registered Mail id <i title="This will be the registered email of the client and if not registered, the client use this email for registering" style="color:#923EFF;" class="uil uil-exclamation-circle"></i></label>
                  <b-form-input style="height: 40px !important" v-model.lazy.trim="$v.form.client_emailid.$model" @keyup="clearerror1()" type="text" placeholder="Registered Email*" v-bind:class="{ 'is-invalid': clientemail_error, 'isinvalid': !$v.form.client_emailid.email}" />
                  <div>
                    <p v-if="clientemail_error" class="login-alert-msg error-content">* Enter client email</p>
                    <p v-if="!$v.form.client_emailid.email" class="login-alert-msg error-content">* Enter the valid client email</p>
                  </div>
                </div>
              </div>
              <div class="col-md-12 p-1" v-bind:class="{ 'disabled-div': preFill }">
                <div class="form-row">
                  <div class="form-group">
                    <label>Title</label>
                    <b-form-input style="height: 40px !important" v-model.lazy.trim="$v.form.job_tittle.$model" @keypress="ValidateAlpha($event)" type="text" placeholder="Job Title*" :state="chkState('job_tittle')"/>
                    <div v-if="$v.form.job_tittle.$error">
                      <p v-if="!$v.form.job_tittle.required" class="login-alert-msg error-content">* Enter the job title</p>
                      <p v-if="!$v.form.job_tittle.maxLength" class="login-alert-msg error-content">* Job title maximum 64 characters</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label >
                      Validity
                    </label>

                    <div class="form-row">
                      <div class="form-group" v-bind:class="{ 'form-group-yes': !form.postinAdvance }">
                        <span class="date select-icon" style="height: 40px;"><i class="uil uil-calender"></i></span>
                        <datetime v-model="form.post_validity" format="dd-MMM-yyyy" :min-datetime="minDatetime1" value-zone="Asia/Tokyo" zone="Asia/Tokyo" v-bind:class="{ 'is-invalid': !chkState('post_validity') }" type="date" placeholder="Select Validity *">
                        </datetime>
                        <div v-if="$v.form.post_validity.$error">
                          <p v-if="!$v.form.post_validity.required" class="login-alert-msg error-content">* Select post validity</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <!-- <div class="form-group">
                    <label>Job Description Template</label>
                    <div class="form-select">
                      <select :disabled="jobtemplatelength < 1" @change="getAutoDatas()"  v-model="form.job_description_template" class="form-control is-valid" v-bind:class="{ 'is-invalid': !chkState('job_description_template') }">
                        <option value='' disabled>Job Description Template</option>
                        <option  v-for="(template, index) in jobtemplate" :key="index" v-bind:value="template._id">{{template.template_name}}</option>
                      </select>
                      <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                    </div>
                  </div> -->
                  <div class="form-group">
                    <label>Overall Experience</label>
                    <div class="form-row">
                      <div class="form-group">
                        <div class="form-select">
                          <select @change="updateyear()" v-model="form.year_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('year_of_experience') }">
                            <option value='' disabled>Select Year *</option>
                            <option value="1">1 year</option>
                            <option v-for="(x, index) in 20" v-bind:value="x + 1" :key="index">{{x + 1}} years</option>
                          </select>
                          <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div v-if="$v.form.year_of_experience.$error">
                          <p v-if="!$v.form.year_of_experience.required" class="login-alert-msg error-content">* Select the year</p>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-select">
                          <select id="month" v-model="form.month_of_experience" class="form-control" v-bind:class="{ 'is-invalid': !chkState('month_of_experience') }">
                            <option value='' disabled>Select Month *</option>
                            <option value="0">0 month</option>
                            <option value="1">1 month</option>
                            <option v-for="(x, index) in 10" v-bind:value="x +1" :key="index">{{x + 1}} months</option>
                          </select>
                          <span for="month" class="select-icon"><i class="fa fa-chevron-down"></i></span>
                        </div>
                        <div v-if="$v.form.month_of_experience.$error">
                          <p v-if="!$v.form.month_of_experience.required" class="login-alert-msg error-content">* Select the month</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <div class="form-select">
                      <label>Primary Skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.primarySkils" v-bind:class="{ 'is-invalid': !chkState('primarySkils') }" placeholder="Select Skills*" label="name" track-by="name" :options="pSkils" :group-select="true" :multiple="true" @input="add()"></multiselect>
                    </div>
                    <div v-if="$v.form.primarySkils.$error && !showRole">
                      <p v-if="!$v.form.primarySkils.required" class="login-alert-msg error-content">* Select the primary skills</p>
                    </div>
                    <div v-if="$v.form.primarySkils.$error && showRole">
                      <p v-if="!$v.form.primarySkils.required" class="login-alert-msg error-content">* Select the required technical skills</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-select">
                      <label>Secondary Skills</label>
                      <multiselect :hide-selected="true" :show-labels="false" class="drop-multi-select" name="skills" v-model="form.secoundarySkills" v-bind:class="{ 'is-invalid': !chkState('secoundarySkills') }" placeholder="Select Skills" label="name" track-by="name" :options="sSkils" :group-select="true" :multiple="true" @input="addsecondaryskill()"></multiselect>
                    </div>
                  </div>
                </div>
                <!-- <div class="form-row">
                  <div class="form-group">
                    <label v-if="form.primarySkils.length > 0">Primary Skills Experience</label>
                    <div style="margin-bottom: -6px;" class="box box-success scroll" v-if="form.primarySkils.length > 0">
                      <div class="mb-2" v-for="(input,k) in inputs" :key="k">
                        <div class="input-group input-group-sm">
                          <div class="input-group-prepend" style="height: 32px;">
                            <span :title="input.skill_name" class="input-group-text over-len" style="width: 40%; text-align:left;border-radius: 0px;">{{input.skill_name}}</span>
                            <input type="hidden" v-model="input.skill_id">
                            <input type="hidden" v-model="input.skill_name">
                            <select :id="input.skill_name" @click="removeerrorp()" style="height: 32px !important;" v-model="input.year" class="form-control exp-group">
                              <option v-for="(x, index) in topyear" v-bind:value="x" :key="index">{{x}}</option>
                              <option value='' disabled>Year *</option>
                            </select>
                            <select @click="removeerrorp()" style="height: 32px !important;" v-model="input.month" class="form-control exp-group">
                              <option value='' disabled>Month *</option>
                              <option value='0'>0</option>
                              <option v-for="(x, index) in 11" v-bind:value="x" :key="index">{{x}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div v-if="pskillerror">
                        <p style="margin-top: 6px;" class="login-alert-msg error-content">* Select primary skills Experience</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label v-if="form.secoundarySkills.length > 0">Secondary Skills Experience</label>
                    <div style="margin-bottom: -6px;" class="box box-success scroll" v-if="form.secoundarySkills.length > 0">
                      <div class="mb-2" v-for="(inputs,i) in secondaryinputs" :key="i">
                        <div class="input-group input-group-sm" style="height: 32px;">
                          <div class="input-group-prepend">
                            <span :title="inputs.skill_name" class="input-group-text over-len" style="width: 40%;text-align:left;border-radius: 0px;">{{inputs.skill_name}}</span>
                            <input type="hidden" v-model="inputs.skill_id">
                            <input type="hidden" v-model="inputs.skill_name">
                            <select @click="removeerrorp()" style="height: 32px !important;" v-model="inputs.year" class="form-control exp-group">
                              <option v-for="(x, index) in topyear" v-bind:value="x" :key="index">{{x}}</option>
                              <option value='' disabled>Year *</option>
                            </select>
                            <select @click="removeerrorp()" style="height: 32px !important;" v-model="inputs.month" class="form-control exp-group">
                              <option value='' disabled>Month *</option>
                              <option value='0'>0</option>
                              <option v-for="(x, index) in 11" v-bind:value="x" :key="index">{{x}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="Sskillerror">
                      <p style="margin-top: 6px;" class="login-alert-msg error-content">* Select secondary skills Experience</p>
                    </div>
                  </div>
                </div> -->
                <div class="form-row">
                  <div class="form-group">
                    <label>Attachment</label>
                    <div class="custom-file-upload">
                      <div v-if="files.length < 1" class="show-doc-empty">Select the File </div>
                      <div class="show-doc" v-if="files.length > 0">
                        <span class="doc-file pull-left" v-for="(x, index) in files.slice(0, 2)" :key="index"><span class="doc-name">{{x.name}} </span><i @click="removeUploading(x)" class="fa fa-times" style="color: #ccc;" aria-hidden="true"></i></span>
                      </div>
                      <label for="file"><i class="uil uil-upload" aria-hidden="true"></i> Upload </label>
                      <input @change="fileUpload($event)" style="visibility: hidden;" type="file" id="file" name="myfiles[]" multiple />
                    </div>
                    <p style="color: #aeaaaa;margin: 3px 0 10px;">Supported format (.pdf, .doc, .docx), Size (Max 2MB)</p>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Job Description</label>
                    <b-form-textarea v-model.lazy.trim="$v.form.org_description.$model" :state="chkState('org_description')" class="textarea" rows="5" placeholder="Enter Job Description"></b-form-textarea>
                    <div v-if="$v.form.org_description.$error">
                      <p v-if="!$v.form.org_description.required" class="login-alert-msg error-content">* Enter the job description</p>
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Remarks</label>
                    <b-form-textarea v-model.lazy.trim="$v.form.job_comments.$model" :state="chkState('job_comments')" class="textarea" rows="5" placeholder="Enter Remarks"></b-form-textarea>
                    <div v-if="$v.form.job_comments.$error">
                      <p v-if="!$v.form.job_comments.required" class="login-alert-msg error-content">* Enter the remarks</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div class="form-submit">
                <input v-if="!preFill" type="reset" @click="resetvalue();" value="Reset" class="submit mr-2 resetbtn" name="reset" id="resetbtn" />
                <button @click="editPost()" v-if="preFill" class="btn btn-success editbtn mr-2" type="button" style="border-radius: 0px;">
                  Edit
                </button>
                <button v-if="shwopostbtn == 'no'" class="buttonload submit" type="button" style="border-radius: 0px;">
                  <i class="fa fa-spinner fa-spin"></i> &nbsp;Post
                </button>
                <input :disabled="createstatus" v-if="shwopostbtn == 'yes'" type="submit" value="Post" class="submit" name="submit" id="submit" />
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
option:not(:first-of-type) {
  color: black;
}
select.form-control {
    height: 40px;
    color: #000;
}
.form-control {
  z-index: inherit !important;
}
.select-icon {
  z-index: inherit !important;
}
.post-alignment {
  width: 48%;
}

.is-invalid input {
  border: 1px solid red;
}
textarea.is-invalid {
  border: 1px solid red;
}
.borders {
  border-bottom: 1px solid;
}

.invalied-validation {
  color: red !important;
}

.custom-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.pop-up-close-icon {
  float: right;
  border: 1px solid gray;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  padding: 3px;
  text-align: center;
  font-size: 16px;
  cursor: pointer;
}

.immediate-new-label {
  margin-bottom: 0px !important;
}

label.checkbox-wrap.is-small {
    padding: 4px 0px !important;
    color: #737373;
    margin: 0px !important;
    font-weight: 100;
    font-size: 13px;
}

.post_interview-type {
  background-color: #5BAD2B !important;
  color: #fff !important;
  border: 1px solid #5BAD2B !important;
}
.in-close {
  float: right;
  padding-right: 15px;
  cursor: pointer;
}

.custom-post-title {
  padding: 15px;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
}

.custom-post-title-msg {
  background: #f7f7f7;
  color: black;
  font-size: 11px;
  padding-left: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.modal-content {
  margin: 0px;
  /* height: -webkit-fill-available; */
  /* overflow: auto; */
}
.btn-close {
  border: none;
  font-size: 20px;
  padding: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #5BAD2B;
  background: transparent;
}

.btn-green {
  color: white;
  background: #5BAD2B;
  border: 1px solid #5BAD2B;
  border-radius: 2px;
}

label .label-new {
  float: right;
  flex: auto;
  position: absolute !important;
  right: 15px;
}
.immediate-label {
  border: 1px solid #5a5a5a;
  padding: 10px;
  margin-bottom: 15px;
  width: fit-content;
  background-color: #f9f9f9;
  color: #000;
}

.newDesign {
  width: 70%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto !important;
}

.pwd_info {
  float: left;
  font-size: 12px;
  padding-bottom: 11px;
  color: red;
  margin-top: -10px;
}

.pwd_info_float_right {
  float: right;
  font-size: 12px;
  padding-bottom: 11px;
  color: #5BAD2B;
  /* cursor: pointer; */
  margin-top: -10px;
}

.pading_____zero {
  margin-bottom: 2px !important;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.login-policy-footer {
  width: 31%;
}

.progressbar {
  height: 5px !important;
  background: #e6e6e6;
}

ul {
  padding: 0px;
}

span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 0.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 7px;
}

.register____user__type {
  color: #000000;
  margin-bottom: 17px !important;
  cursor: pointer;
}

.progress_____round {
  border: 1px solid #5BAD2B;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #5BAD2B;
  font-weight: bold;
}

.progress_____round____hidden {
  border: 1px solid #bbb4b4;
  padding: 9px;
  border-radius: 21px;
  width: 40px;
  height: 40px;
  color: #bbb4b4;
  font-weight: bold;
}
svg {
  width: 100%;
}

.content-title {
  padding: 35px 0px 35px 105px;
}

.content-title-header {
  font-size: 22px;
  color: #000000;
}

.content-title-sub-header {
  color: #2F2F2F;
  font-size: 15px;
}

display-flex,
.signup-content,
.form-row,
.form-radio,
.select-icon,
.select-icon i {
  display: flex;
  display: -webkit-flex;
}

/* @extend list-type-ulli; */
list-type-ulli {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.file-loading {
  width: 50%;
}

img {
  max-width: 254px;
  height: auto;
}

figure {
  margin: 0;
}

.clear {
  clear: both;
}

.container {
  width: 100%;
  position: relative;
  margin: 0 auto;
  /* background: #fff; */
}

.signup-img {
  width: 30%;
}

.signup-form {
  width: 70%;
}

.form-row {
  margin: 0 -15px;
}

.form-row .form-group {
  width: 50%;
  padding: 0 15px;
}

.form-row .form-group-yes {
  width: 100% !important;
  padding: 0 15px;
}

.form-group {
  margin-bottom: 10px;
  position: relative;
}
label {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 2px;
  display: block;
  color: #5B5B5B;
}

.form-radio {
  margin-bottom: 18px;
}

.form-radio input {
  width: auto;
  display: inline-block;
}

.radio-label {
  padding-right: 72px;
}

.form-radio-item {
  position: relative;
  margin-right: 45px;
}

.form-radio-item label {
  font-weight: 500;
  font-size: 13px;
  padding-left: 25px;
  position: relative;
  z-index: 9;
  display: block;
  cursor: pointer;
}

.check {
  display: inline-block;
  position: absolute;
  border: 1px solid #ebebeb;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  height: 13px;
  width: 13px;
  top: 4px;
  left: 0px;
  z-index: 5;
  transition: border .25s linear;
  -webkit-transition: border .25s linear;
}

.check:before {
  position: absolute;
  display: block;
  content: '';
  width: 9px;
  height: 9px;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  -o-border-radius: 50%;
  -ms-border-radius: 50%;
  top: 2px;
  left: 2px;
  margin: auto;
  transition: background 0.25s linear;
  -webkit-transition: background 0.25s linear;
}

input[type=radio] {
  position: absolute;
  visibility: hidden;
}

input[type=radio]:checked~.check {
  border: 1px solid #4dbd74;
}

input[type=radio]:checked~.check::before {
  background: #4dbd74;
}

.form-select {
  position: relative;
}

select {
  appearance: none !important;
  -moz-appearance: none !important;
  -webkit-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  position: relative;
  background: 0 0;
  z-index: 10;
  cursor: pointer;
}

.select-icon {
  z-index: 999;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
}

.select-icon i {
  justify-content: center;
  -moz-justify-content: center;
  -webkit-justify-content: center;
  -o-justify-content: center;
  -ms-justify-content: center;
  align-items: center;
  -moz-align-items: center;
  -webkit-align-items: center;
  -o-align-items: center;
  -ms-align-items: center;
  width: 40px;
  height: 20px;
  font-size: 18px;
  color: #999;
}

.form-submit {
  text-align: right;
  padding-top: 10px;
}

@media (min-width: 1024px) {
  .date.select-icon {
    right: 15px!important;
  }
}

@media screen and (max-width: 1024px) {
  /* .register-form {
    padding: 0px 40px 50px 0px;
  } */

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 125px;
  }

  .image-design {
    height: 254px;
  }

  .container {
    width: 100%;
    max-width: 100% !important;
  }
}

@media screen and (max-width: 992px) {
  .container {
    width: 100%;
    max-width: 100% !important;
  }

  .signup-img {
    width: 30%;
  }

  .signup-form {
    width: 70%;
  }

  .image-width {
    width: 100%;
    height: 100%
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }
}
@media screen and (max-width: 800px) {
  .signup-content {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }

  .signup-img,
  .signup-form {
    width: 100%;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
  }

  .image-design {
    height: 354px;
  }

  .content-title {
    padding: 35px 0px 35px 0px;
    text-align: center;
  }

}

@media screen and (max-width: 768px) {

  .signup-img,
  .signup-form {
    width: 100%;
  }
}

@media screen and (max-width: 575px) {
  .form-row {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
    margin: 0px;
  }

  .form-row .form-group {
    width: 100%;
    padding: 0px;
  }

  .radio-label {
    padding-right: 22px;
  }

  .form-radio-item {
    margin-right: 25px;
  }
}

@media screen and (max-width: 480px) {
  .form-radio {
    flex-direction: column;
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    -ms-flex-direction: column;
  }
}

.image-design {
  margin-left: auto;
  margin-right: auto;
  display: block;
}

.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}

.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}

.vdatetime-popup__header {
  background: #5BAD2B !important;
}
.vdatetime-calendar__month__day--selected > span > span, .vdatetime-calendar__month__day--selected:hover > span > span {
    color: #fff;
    background: #5BAD2B !important;
}
.exp-group {
  border-radius: 0;
  border: 1px solid #8888881a !important;
  opacity: 1;
}
.interview-type {
    border-radius: 0px;
}
.multiselect__input {
  font-size: 14px;
}
.resetbtn {
  background: #F2F2F2 0% 0% no-repeat padding-box !important;
  border: 1px solid #a1a1a19c !important;
  opacity: 1;
  color: black !important;
}
.modal-backdrop.in {
    opacity: 0;
}
.modal-backdrop {
    position: inherit;
}
.modal-header {
    padding: 0px !important;
}
@media (min-width: 768px){
  .modal-dialog {
      width: 800px !important;
      margin: 30px auto !important;
  }
}
.custom-file-upload {
  height: 40px;
  border: 1px solid #e7e7e7;
  opacity: 1;
}
.custom-file-upload label {
  text-align: center;
  width: 30%;
  float: right;
  margin-top: 2px;
  margin-right: 2px;
  color: white;
  font-weight: 100;
  padding: 7px 2px 7px 0px;
  background-color: #5bad2b;
}
.show-doc {
  width: 68%;
  margin-top: 7px;
  float: left;
  height: 30px;
}
.doc-file {
  background: #F5F5F5 0% 0% no-repeat padding-box;
  border: 1px solid #E0E0E0;
  border-radius: 18px;
  opacity: 1;
  padding: 4px;
  /* display: flex !important; */
  width: 47%;
  margin-left: 2px;
  margin-top: -3px;
}
.doc-name {
  width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
}
.doc-file .fa {
  margin-top: -17px;
  cursor: pointer;
  width: 10%;
  float: right;
  margin-right: 4px;
}
.show-doc-empty {
  width: 60%;
  float: left;
  margin-left: 10px;
  margin-top: 7px;
  color: #979797;
}
.custom-file-upload.is-invalid {
  border: 1px solid red;
}
.error-content {
  font-size: 12px;
}
.form-group {
  margin-bottom: 5px !important;
}
.createposticon {
  width: 18px;
  max-width: 121px !important;
  margin-top: -5px;
}
@media (min-width: 1400px) {
  .modal-dialog {
      width: 980px !important;
      margin: 30px auto !important;
  }
}
.scroll {
  overflow-x: scroll;
  max-height: 123px;
  height: auto;
  overflow-y: scroll;
}
.box {
  /* margin-bottom: -6px; */
  box-shadow: none;
}
hr {
  border-top: 1px solid #e7e7e7;
}
.emaillist {
  width: fit-content;
  background-color: aliceblue;
  padding: 5px;
  border-radius: 14px;
  margin-right: 5px;
  cursor: pointer;
}
.disabled-div {
  pointer-events: none;
  opacity: 0.4;
}
.editbtn {
  width: 120px;
  height: 40px;
  font-size: 16px;
  padding: 0px;
  border: none;
}
@media screen and (min-width: 769px){
  .modal-content, .modal-card {
      margin: 0 auto;
      width: 801px;
  }
}
.modal { overflow: auto !important; }
.modal-header {
  padding: 8px !important;
}
</style>
